import Table from './table';

export * from './table';

export default Table;
